import { http, HttpResponse } from 'msw';
import { accountListData } from '../data/accounts/account-list';
import { preAccountListData } from '../data/accounts/pre-account-list';
import { onboardingLinkData } from '../data/accounts/onboarding-link';
import { accountOptionsData } from '../data/accounts/account-options';
import { addAccountData } from '../data/accounts/add-account';
import { isProfileWithoutOnboarding } from '~/utils/profiles-without-onboarding';
import type { AddIndividualAccountBody, AddLegalEntityAccountBody } from '~/types';

const route = useRoute();
let nextMockProfileId = 1;
let nextMockWalletId = 1;

export const accountsHandlers = [
  http.get('**/accounts/options', () => {
    return HttpResponse.json({
      ...accountOptionsData.individualOptions,
      ...accountOptionsData.cseOptions,
      ...accountOptionsData.legalEntityOptions
    });
  }),

  http.post('**/api/**/accounts/individual', async ({ request }) => {
    const body = (await request.json()) as AddIndividualAccountBody;
    if (isProfileWithoutOnboarding(body?.profile)) {
      return HttpResponse.json(addAccountData.creationInProgressAccount);
    }
    return HttpResponse.json(addAccountData.awaitingInfoAccount);
  }),

  http.post('**/api/**/accounts/legal-entity', async ({ request }) => {
    const body = (await request.json()) as AddLegalEntityAccountBody;
    if (isProfileWithoutOnboarding(body?.profile)) {
      return HttpResponse.json(addAccountData.creationInProgressAccount);
    }
    return HttpResponse.json(addAccountData.awaitingInfoAccount);
  }),

  http.post('**/api/**/accounts/**/onboarding', () => {
    return HttpResponse.json(onboardingLinkData);
  }),

  http.post('**/api/**/accounts/:accountType/:id/profiles', () => {
    return HttpResponse.json({ id: `generated-profile-${nextMockProfileId++}` });
  }),

  http.post('**/api/**/accounts/:accountType/:id/profiles/:profileId/wallets', () => {
    return HttpResponse.json({ id: nextMockWalletId++ });
  }),

  http.get('**/api/**/accounts/:id', () => {
    const account = accountListData.Data.find((account) => account.Id === route.params.id);
    return HttpResponse.json(account);
  }),

  http.get('**/api/**/accounts', () => {
    return HttpResponse.json(accountListData);
  }),

  http.get('**/api/**/PendingAccounts', () => {
    return HttpResponse.json(preAccountListData);
  })
];
